import { initializeApp } from "firebase/app";
import {
  getAuth,
  GithubAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};


const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();


const PROVIDERS = {
  google: googleProvider,
  github: githubProvider,
};

const normalizeProvider = (provider) => {
  if (!provider) return null;
  return String(provider).trim().toLowerCase();
};

export const signInWithProvider = async (provider) => {
  const key = normalizeProvider(provider);
  const selectedProvider = PROVIDERS[key];

  if (!selectedProvider) {
    throw new Error(`Unsupported auth provider: ${provider}`);
  }

  const result = await signInWithPopup(auth, selectedProvider);
  const idToken = await result.user.getIdToken();
  return idToken;
};

// Backwards-compatible exports (keep existing imports working)
export const signInWithGoogle = () => signInWithProvider("google");
export const signInWithGithub = () => signInWithProvider("github");

export { app };

